export default __webpack_public_path__ + "static/media/010_photo.625ac914.jpg";